import type { RouterConfig } from '@nuxt/schema';
import { storyblokProductFilterRootPaths } from '#shared/data/storyblokProductFilterRootPaths';

const usesCustomScroll = (path: string) =>
    storyblokProductFilterRootPaths.some(
        (rootPath) => path === rootPath || path.startsWith(`${rootPath}/`),
    );

export default <RouterConfig>{
    scrollBehavior(to, _from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }

        if (!usesCustomScroll(to.path)) {
            return { left: 0, top: 0 };
        }

        if (to.hash) {
            return {
                el: to.hash,
                top: 16,
                behavior: 'smooth',
            };
        }

        return { left: 0, top: 0 };
    },
};
